module.exports = __webpack_public_path__ + "static/media/hs5.5dea0292.jpg";